import { loadinganimationStore } from "./loadinganimationStore"
import { navigationStore } from "./navigationStore"
import { navigationStoreNotPersisted } from "./navigationStoreNotPersisted"
import { userStore } from "./userStore"
import { deviceStore } from "./deviceStore"
import { studioStore } from "./studioStore"
import { workingoutStore } from "./workingoutStore"
import { shopStore } from "./shopStore"
import { runWorkoutStore } from "./runWorkoutStore"
import { panelStore } from "./panelStore"
import { chatStore } from "./chatStore"
import { mailStore } from "./mailStore"
import { liveQuizStore } from "./liveQuizStore"
import { homeOverviewStore } from "./homeOverviewStore"
import { homeSliderStore } from "./homeSliderStore"
import { pruneHomeCaches } from "@/services/homeCache"
import VuexPersistence from "vuex-persist"
import localForage from "localforage"

pruneHomeCaches()

const persistedModules = [
  "loadinganimationStore",
  "navigationStore",
  "userStore",
  "workingoutStore",
  "deviceStore",
  "shopStore",
  "studioStore",
  "runWorkoutStore",
  "panelStore",
]

const vuexLocal = new VuexPersistence({
  modules: persistedModules,
  // The modules option selects data, but does not filter mutation triggers.
  filter: ({ type }) => persistedModules.includes(type.split("/")[0]),
  storage: localForage,
  asyncStorage: true,
})

import Vuex from "vuex"
import Vue from "vue"
Vue.use(Vuex)

export const store = new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    loadinganimationStore,
    navigationStore,
    navigationStoreNotPersisted,
    userStore,
    studioStore,
    workingoutStore,
    deviceStore,
    shopStore,
    runWorkoutStore,
    panelStore,
    chatStore,
    mailStore,
    liveQuizStore,
    homeSliderStore,
    homeOverviewStore,
  },
})
